import ReactDOM from 'react-dom';
import { useState } from '@wordpress/element';
import Content from './navigation/content';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navigation from './navigation/navigation';
import { Helmet } from './helper/helmet/helmet';
import { CloseButtonSVG } from "./icon";
import { closeBanner } from "./helper/axios";

if (document.getElementById('jkit-admin-dashboard')) {
    const loadContent = () => {

        const {
            bannerData,
        } = window['JkitDashboardOption'] || {};
        const today = new Date();
        const expired = new Date(bannerData?.expired);
        const EventBanner = () => {
            const [close, setClose] = useState(false);
            return <>
                {
                    (bannerData && today <= expired && !close) && <div className="jkit-discount-banner">
                        <a href={bannerData?.url + '&utm_medium=dashboard-discount-banner'} target="_blank" rel="noreferrer" >
                            <img src={bannerData?.banner} alt="event-banner" />
                        </a>
                        <button onClick={() => closeBanner(setClose)} type="button" className="jkit-close-banner"><CloseButtonSVG /></button>
                    </div>
                }
            </>;
        };

        ReactDOM.render(
            <Router>
                <div className="jeg-elementor-kit-dashboard" >
                    <EventBanner />
                    <Helmet>
                        <link rel="preconnect" href="https://fonts.googleapis.com" />
                        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
                        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap" rel="stylesheet" />
                    </Helmet>
                    <Navigation />
                    <Routes>
                        <Route path="*" element={<Content />} />
                    </Routes>
                </div>
            </Router>,
            document.getElementById('jkit-admin-dashboard')
        );
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        loadContent();
    } else {
        window.addEventListener('load', () => {
            loadContent();
        })
    }
}
